"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Passenger = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const TransformToDateWithoutTime_1 = require("../transformers/TransformToDateWithoutTime");
const strings_1 = require("../utils/strings");
const UserSharedPosition_1 = require("./UserSharedPosition");
let Passenger = class Passenger {
    type;
    userId;
    birthdayAt;
    firstName;
    lastName;
    email;
    countryId;
    assignationId = null;
    phoneNumber;
    childSeatType;
    luggage = [legacy_enums_1.LuggageType.CarryOn, legacy_enums_1.LuggageType.Suitcase];
    sharedPosition;
    isLead() {
        return this.type === legacy_enums_1.PassengerType.Lead;
    }
    isAdult() {
        return this.type === legacy_enums_1.PassengerType.Adult;
    }
    isChild() {
        return this.type === legacy_enums_1.PassengerType.Child;
    }
};
exports.Passenger = Passenger;
__decorate([
    (0, type_graphql_1.Field)(() => String),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Passenger.prototype, "type", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((passenger) => passenger.type === legacy_enums_1.PassengerType.Lead),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : String(value))),
    __metadata("design:type", String)
], Passenger.prototype, "userId", void 0);
__decorate([
    (0, type_graphql_1.Authorized)(),
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.ValidateIf)((passenger) => passenger.type === legacy_enums_1.PassengerType.Lead || passenger.type === legacy_enums_1.PassengerType.Child),
    (0, class_transformer_1.Expose)(),
    TransformToDateWithoutTime_1.TransformToDateWithoutTime,
    __metadata("design:type", Date)
], Passenger.prototype, "birthdayAt", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.MaxLength)(64),
    (0, class_validator_1.IsString)()
    // @IsDefined()
    ,
    (0, class_validator_1.ValidateIf)((passenger) => passenger.type === legacy_enums_1.PassengerType.Lead),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Passenger.prototype, "firstName", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.MaxLength)(64),
    (0, class_validator_1.IsString)()
    // @IsDefined()
    ,
    (0, class_validator_1.ValidateIf)((passenger) => passenger.type === legacy_enums_1.PassengerType.Lead),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Passenger.prototype, "lastName", void 0);
__decorate([
    (0, type_graphql_1.Authorized)(),
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_transformer_1.Transform)(({ value }) => (!(0, strings_1.stringIsEmail)(value) ? undefined : value.trim())),
    (0, class_validator_1.ValidateIf)((passenger) => passenger.type !== legacy_enums_1.PassengerType.Lead),
    (0, class_validator_1.MaxLength)(256),
    (0, class_validator_1.IsEmail)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isNotUndefinedOrNull)(value) ? value.trim() : undefined)),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((passenger) => passenger.type === legacy_enums_1.PassengerType.Lead),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Passenger.prototype, "email", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsUUID)("4")
    // @IsDefined()
    // @ValidateIf((passenger) => passenger.type == PassengerType.Lead)
    ,
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Passenger.prototype, "countryId", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => String, { nullable: true }),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Passenger.prototype, "assignationId", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.MaxLength)(32),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.transformPhoneNumberToNormalizedForm)(value)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Passenger.prototype, "phoneNumber", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int, { nullable: true }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.ValidateIf)((passenger) => passenger.type === legacy_enums_1.PassengerType.Child),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Passenger.prototype, "childSeatType", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => [Number], { nullable: true }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Array)
], Passenger.prototype, "luggage", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => UserSharedPosition_1.UserSharedPosition, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", UserSharedPosition_1.UserSharedPosition)
], Passenger.prototype, "sharedPosition", void 0);
exports.Passenger = Passenger = __decorate([
    (0, type_graphql_1.ObjectType)("Passenger"),
    (0, type_graphql_1.InputType)("PassengerInput"),
    (0, class_transformer_1.Exclude)()
], Passenger);
//# sourceMappingURL=Passenger.js.map